import { createEntityAdapter } from '@reduxjs/toolkit';
import { ThemeResponsePrivate } from '@tests/types';

export const themesAdapter = createEntityAdapter<ThemeResponsePrivate<string>>();
